import tippy from "tippy.js";
import jquery from "jquery";
import { addToGlobalThisRet, initIntersectionObserver } from "@plugins";

const $ = jquery;

$(document).ajaxSuccess(() => initTooltips());

window.addEventListener("load", () => initTooltips());

function initTooltips() {
    const tooltips = document.querySelectorAll(".js-tooltip");

    if (tooltips) {
        for (const tooltip of tooltips) {
            setTimeout(() => initIntersectionObserver(tooltip, initTooltip), 0);
        }
    }
}

function initTooltip(tooltip) {
    if (!tooltip.classList.contains("tooltip-initialized")) {
        tippy(tooltip, {
            arrow: true,
            placement: "auto", // top, right, bottom, left
            trigger: "mouseenter click",
            interactive: true,

            allowHTML: true,
            hideOnClick: true,
            theme: "light",
            content: tooltip.querySelector(".js-tooltip-content"),
            popperOptions: {
                modifiers: [
                    {
                        name: "flip",
                        options: {
                            allowedAutoPlacements: ["top", "bottom"],
                        },
                    },
                ],
            },
            appendTo: () => document.body,
        });

        tooltip.classList.add("tooltip-initialized");
    }
}

addToGlobalThisRet(initTooltips, "initTooltips");
